import { XIcon } from 'lucide-react';

import ControlButton from './ControlButton';

function ResetButton({ onClick }: { onClick: () => void }) {
  return (
    <ControlButton variant="ghost" onClick={onClick} aria-label="Reset timer">
      <XIcon className="size-8 text-red-500" />
    </ControlButton>
  );
}

export default ResetButton;
